/**
 * 同步多 Tab 间 store 状态
 * TODO：目前对 persist 不为 true 的 store 应该不支持，后续需要支持
 * @returns
 */
export function createSyncPlugin () {
  return ({ options, store }) => {
    /**
     * Only proceed if sync option is true
     */
    if (!options.sync) return

    /**
     * Only proceed if BroadcastChannel is available
     */
    if (!(window && 'BroadcastChannel' in window)) return

    const channel = new BroadcastChannel(`pinia-sync-${store.$id}`)

    let syncingRemotePatch = false

    // 监听来自其他窗口的消息并更新 store
    channel.addEventListener('message', (event) => {
      const newValue = event.data
      if (newValue) {
        const parsedData = JSON.parse(newValue)
        syncingRemotePatch = true
        store.$patch(parsedData)
        syncingRemotePatch = false
      }
    })

    // 监听本窗口内的 store 变化并广播消息
    store.$subscribe((_mutation, state) => {
      if (syncingRemotePatch) return
      const deserializeData = JSON.stringify(state)
      channel.postMessage(deserializeData)
    })
  }
}
